export default __webpack_public_path__ + "static/googleOptimize-8f3d6e0e22f9219eae0cd654d98a328e.png";